import React from 'react';
import './StatsCards.css';

export interface StatCardItem {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  iconColorClass?: string; // e.g. "stat-color-brand", "stat-color-teal", etc.
}

interface StatsCardsProps {
  items: StatCardItem[];
}

export function StatsCards({ items }: StatsCardsProps) {
  return (
    <div className="stats-cards-grid">
      {items.map((item, index) => (
        <div className="stat-card" key={index}>
          <div className={`stat-card-icon ${item.iconColorClass || 'stat-color-brand'}`}>
            {item.icon}
          </div>
          <div className="stat-card-info">
            <span className="stat-card-number">{item.value}</span>
            <span className="stat-card-label">{item.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
